// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Created: 8/30/2019, 10:49:08 AM
// Hash: -1523518543
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';

import { SecurityUser } from './models/securityuser';
import { HTTP_NOAUTH } from 'carehub-root/shared/HTTP_NOAUTH';

@Injectable({
  providedIn: 'root',
})
export class SecurityUsersApiService {
  constructor(@Inject(HTTP_NOAUTH) private http: HttpClient) {}

  ApiSecurityUsersTestGet(): Observable<any> {
    const url = environment.securityApiRoot + `/api/SecurityUsers/test`;
    return this.http.get<any>(url);
  }

  getSecurityUserByUserId(
    accessToken: string,
    userId: string
  ): Observable<SecurityUser> {
    const url = environment.securityApiRoot + `/api/SecurityUsers/${userId}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      }),
    };

    return this.http.get<SecurityUser>(url, httpOptions);
  }
}
